module.exports = __webpack_public_path__ + "img/terroir-liquify-1-mobile.5a632f43.jpg";